import { render, staticRenderFns } from "./m-baseMaterial-setting-modal.vue?vue&type=template&id=5ad4bf12&scoped=true&"
import script from "./m-baseMaterial-setting-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-baseMaterial-setting-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-baseMaterial-setting-modal.vue?vue&type=style&index=0&id=5ad4bf12&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4bf12",
  null
  
)

export default component.exports